import type { UseInfiniteQueryOptions, UseInfiniteQueryResult } from '@tanstack/react-query';
import { useInfiniteQuery } from '@tanstack/react-query';

/**
 * ErrorBoundary와 연동되는 useInfiniteQuery 래퍼
 * 에러 발생 시 자동으로 throw하여 상위 ErrorBoundary가 처리하도록 함
 */
export const useInfiniteQueryWithBoundary = <
  TQueryFnData = unknown,
  TError = Error,
  TData = TQueryFnData,
  TQueryKey extends readonly unknown[] = readonly unknown[],
  TPageParam = unknown,
>(
  options: UseInfiniteQueryOptions<TQueryFnData, TError, TData, TQueryKey, TPageParam>
): UseInfiniteQueryResult<TData, TError> => {
  const result = useInfiniteQuery(options);

  if (result.error) {
    throw result.error;
  }

  return result;
};
